import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoginService } from '@services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styleUrls: ['./recuperar-password.component.css'],
  imports: [CommonModule, ReactiveFormsModule],
})
export class RecuperarPasswordComponent {
  formRecuperar: FormGroup;
  mensaje: string = '';

  constructor(private fb: FormBuilder, private loginService: LoginService,public router: Router) {
    this.formRecuperar = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit() {
    if (this.formRecuperar.valid) {
      const email = this.formRecuperar.value.email;
      // Aquí deberías llamar a tu servicio de recuperación de contraseña
      this.loginService.RecuperarPassword({ email: email }).then(response => {
          this.mensaje = `Si el correo ${email} está registrado, recibirás un enlace para restablecer tu contraseña. Verifica tu bandeja de entrada y la carpeta de spam.`;

      }).catch(error => {
        console.error('Error al enviar la solicitud:', error);
      });

    
      this.formRecuperar.reset();
    }
  }
}
